import { Pipe, PipeTransform } from '@angular/core';
import { Translator } from './services/translator/translator.service';

type typeTranslate = 'UPPER' | 'LOWER' | 'CAPITALIZE' | 'AS_IS';

@Pipe({
  name: 'translateV2',
  pure: false
})
export class TranslatePipeV2 implements PipeTransform {

  data: any = {};

  constructor(private translate: Translator) {
    this.loadData();
  }

  async loadData() {

    this.translate.dataLanguage$.subscribe((data) => {
      if (data) {
        this.data = this.translate.GetTranslations();
      }
    });
  }

  transform(key: string | number | null | undefined, mode: typeTranslate = 'CAPITALIZE'): any {
    const keyStr = key != null ? String(key) : '';
    /* AS_IS: mostrar o texto literal; não consultar dicionário (evita trocar maiúsculas/minúsculas ou substituir texto livre). */
    if (mode === 'AS_IS') {
      return keyStr;
    }
    let trad = this.data;
    // No traducir claves que son solo dígitos (p. ej. IDs de filtros como Padre=1) para evitar mostrar "Error genérico"
    const isNumericId = /^\d+$/.test(keyStr.trim());
    let severalKeys = keyStr.split(',');

    const valuesBasedOnKyes = severalKeys.length > 1 ?
      severalKeys.reduce((result, curr) => {
        if (this.data[curr]) {
          result += result ? `, ${this.data[curr]}` : this.data[curr]
        }

        return result;
      }, '') : null;

    const value: string = String(
      valuesBasedOnKyes ? valuesBasedOnKyes : (isNumericId ? keyStr : (trad[keyStr] ?? keyStr))
    );

    if (!valuesBasedOnKyes) {
      switch (mode) {
        case 'UPPER':
          return value.toUpperCase();
        case 'LOWER':
          return value.toLowerCase();
        case 'CAPITALIZE':
          return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
        default:
          return value;
      }
    }

    return valuesBasedOnKyes
  }

}
